Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addComponent = addComponent;
exports.removeComponent = removeComponent;
exports.watchComponent = watchComponent;
var _constants = require('../constants');
var _query = require('./query');
function addComponent(component) {
  return {
    type: _constants.ADD_COMPONENT,
    component: component
  };
}
function removeComponent(component) {
  return {
    type: _constants.REMOVE_COMPONENT,
    component: component
  };
}
function updateWatchman(component, react) {
  return {
    type: _constants.WATCH_COMPONENT,
    component: component,
    react: react
  };
}
function watchComponent(component, react) {
  return function (dispatch) {
    dispatch(updateWatchman(component, react));
    dispatch((0, _query.executeQuery)(component));
  };
}